"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.powerOf = powerOf;

require("@polkadot/api-augment");

var _bignumber = require("bignumber.js");

var _rxjs = require("rxjs");

var _util = require("@polkadot/api-derive/util");

var _util2 = require("@polkadot/util");

// Copyright 2017-2022 @darwinia/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
const ration = 500000000;

function stashPower(api, accountId) {
  return api.query.staking.bonded(accountId).pipe((0, _rxjs.switchMap)(account => account.isNone ? (0, _rxjs.of)({
    power: new _util2.BN('0')
  }) : api.queryMulti([api.query.staking.ktonPool, api.query.staking.ringPool, [api.query.staking.ledger, account.unwrap()]]).pipe((0, _rxjs.map)(_ref => {
    let [ktonTotal, ringTotal, ledger] = _ref;

    if (ledger.isNone) {
      return {
        power: new _util2.BN('0')
      };
    }

    const l = ledger.unwrap();
    const active = new _bignumber.BigNumber(l.active.toString());
    const activeKton = new _bignumber.BigNumber(l.activeKton.toString());
    const ringPower = active.div(ringTotal.toString()).multipliedBy(ration);
    const ktonPower = activeKton.div(ktonTotal.toString()).multipliedBy(ration);
    return {
      power: new _util2.BN(ringPower.plus(ktonPower).toFixed(0).toString())
    };
  }))));
}
/**
 * @name inProcessOrders
 * @return PowerOf
 * @description query account power
 * @example
 * <BR>
 *
 * ```javascript
 * api.derive.staking.powerOf(accountId, (powerOf) => {
 *   console.log(`account ${accountId}  staking  power is  ${powerOf.power}`);
 * });
 * ```
 */


function powerOf(instanceId, api) {
  return (0, _util.memo)(instanceId, accountId => stashPower(api, accountId));
}